<template>
  <div v-loading="loading">
    <el-form :model="formData" ref="formData" :rules="rulesAdd" label-width="120px" label-position="right" size="small"
             style="margin-right: 3vw">
      <el-row>
        <el-col :span="12">
          <el-form-item label="岗位名称：" prop="job_name" label-width="120px" style="height: 50%">
            <el-input v-model="formData.job_name" placeholder="请输入岗位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历要求：" prop="education" label-width="120px" style="height: 50%">
            <el-input v-model="formData.education" placeholder="请输入学历要求"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="专业方向：" prop="major_direction" label-width="120px" style="height: 50%">
            <el-input v-model="formData.major_direction" placeholder="请输入专业方向"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="经验要求：" prop="experience" label-width="120px" style="height: 50%">
            <el-input v-model="formData.experience" placeholder="请输入经验要求"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工作地点：" prop="work_location" label-width="120px" style="height: 50%">
            <el-input v-model="formData.work_location" placeholder="请输入工作地点"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司/部门：" prop="department" label-width="120px" style="height: 50%">
            <el-input v-model="formData.department" placeholder="请输入公司/部门"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否发布：" prop="is_enable" label-width="120px" style="height: 50%">
            <el-radio-group v-model="formData.is_enable">
              <el-radio :label="1">发 布</el-radio>
              <el-radio :label="0">不发布</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="text-align:center;">
      <el-button type="primary" @click="addOrUpdate" size="small">保存</el-button>
    </div>
  </div>
</template>
<script>
import Xheditor from "@/components/XhComponents/XhEditor";
import AttachmentList from "@/components/AttachmentList";
import AttachmentUpload from "@/components/AttachmentUpload";

export default {
  name: "HistoryEdit",
  props: ["data", "title"],
  components: {Xheditor, AttachmentList, AttachmentUpload},
  data() {
    return {
      formData: this.data,
      rulesAdd: {
        job_name: [{required: true, message: "必填项", trigger: "blur"}],
        education: [{required: true, message: "必填项", trigger: "blur"}],
        major_direction: [{required: true, message: "必填项", trigger: "blur"}],
        experience: [{required: true, message: "必填项", trigger: "blur"}],
        work_location: [{required: true, message: "必填项", trigger: "blur"}],
        department: [{required: true, message: "必填项", trigger: "blur"}],
      },
      loading: false,
      fileID: this.data.id,
    }
  },
  methods: {
    addOrUpdate() {
      let that = this;
      this.$refs.formData.validate((valid) => {
        if (valid) {
          that.$api.post("/OpenPositions/saveData", that.formData,
              function (res) {
                if (res.code === "200" && res.msg === "true") {
                  that.$emit("closeModal");
                  that.$message.success("保存成功");
                } else {
                  that.$message.warning("保存失败");
                }
              },
          );
        } else {
          return false;
        }
      });
    },
    afterload() {
      this.loading = false;
    },
    getAttachList(id) {
      this.$refs["fileList" + id].GetAttachmentList();
    },
    change(val) {
      var that = this;
      that.formData.about_content = val;
    },
  },
  mounted() {
  },
  created() {
  },
  watch: {
    data: function () {
      this.formData = this.data;
    },
  }
}
</script>
<style scoped lang="less">

</style>
